import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function CheckCircleSolid({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#clip0_898_40635)">
        <path
          d="M7.99978 0.888672C4.07889 0.888672 0.888672 4.07889 0.888672 7.99978C0.888672 11.9207 4.07889 15.1109 7.99978 15.1109C11.9207 15.1109 15.1109 11.9207 15.1109 7.99978C15.1109 4.07889 11.9207 0.888672 7.99978 0.888672ZM11.4158 5.96245L7.63801 10.8513C7.51712 11.0078 7.33312 11.1029 7.13578 11.11C7.12689 11.11 7.11889 11.11 7.11089 11.11C6.92245 11.11 6.74201 11.03 6.61489 10.8896L4.61489 8.66734C4.36867 8.39356 4.39089 7.97223 4.66467 7.72512C4.93934 7.47978 5.35889 7.50112 5.60689 7.77489L7.07178 9.40334L10.3616 5.14645C10.5864 4.85489 11.006 4.80156 11.2967 5.02645C11.5882 5.25134 11.6416 5.67 11.4167 5.96156L11.4158 5.96245Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_898_40635">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
